<div class="container-fluid" *ngIf="!ganador" (click)="abrirPerfil()" style="cursor: pointer;">
    <div class="row">
        <div class="col-12 perfilImg w-100"
            style="min-height: 45vh; max-height: 45vh;background-size: cover; background-repeat: no-repeat; background-position: center center;"
            [ngStyle]="{ 'background-image': 'url(' + urlImagen(perfil.imagen) + ')'}">
        </div>
    </div>
    <div class="row pt-3">
        <div class="col-8">
            <p class="nombre mb-0">{{perfil.nombre}} {{perfil.apellido}}</p>
            <p class="categoria">{{perfil.profesion}}</p>
        </div>
        <div class="col-4 colImgCategoria">
            <img class="imgCategoria ml-auto" [src]="perfil.categoria.imagen" alt="Categoria">
        </div>
    </div>
    <div class="row descripcion">
        <div class="col-12">
            <p *ngIf="perfil.descripcion_corta == '' || perfil.descripcion_corta == null">
                {{perfil.descripcion_larga.length > 50 ? perfil.descripcion_larga.substring(0, 50) + '...' :
                perfil.descripcion_larga}}
            </p>
            <p *ngIf="perfil.descripcion_corta != '' && perfil.descripcion_corta != null">
                {{perfil.descripcion_corta.length > 50 ? perfil.descripcion_corta.substring(0, 50) + '...' :
                perfil.descripcion_corta}}
            </p>
        </div>
    </div>
    <div class="row" *ngIf="!finalista">
        <div class="col-12">
            <span class="votos"><strong>{{perfil.votos || 0}} {{ (perfil.votos || 0) > 1 ? 'Votos' :
                    'Voto'}}</strong></span>
        </div>
    </div>
    <div class="row" *ngIf="finalista">
        <div class="col-12">
            <button class="btn btn-primary btn-finalista">Finalista</button>
        </div>
    </div>
</div>

<div class="container-fluid ganador" *ngIf="ganador" (click)="abrirPerfil()" style="cursor: pointer;">
    <div class="row">
        <div class="col-6 colGanadorImg">
            <div class="perfilImg" [ngStyle]="{ 'background-image': 'url(' + urlImagen(perfil.imagen) + ')'}">

            </div>
        </div>
        <div class="col-6">
            <div class="row labels">
                <div class="col">
                    <logo-edicion [numeroEdicion]="perfil?.periodo?.periodo"
                        [anoEdicion]="perfil?.periodo?.periodo"></logo-edicion>
                </div>
                <div class="col">
                    <div class="d-flex flex-column text-center">
                        <img class="imagenLabel" [src]="perfil?.categoria?.imagen" alt="Categoria">
                        <span>{{perfil?.categoria?.nombre}}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h6 class="nombrePerfil">{{perfil.nombre}} {{perfil.apellido}}</h6>
                </div>
            </div>
            <div class="row rowProfesion">
                <div class="col-12">
                    <span class="profesion">{{perfil.profesion}}</span>
                </div>
            </div>
            <div class="row rowDescripcionCorta">
                <div class="col-12">
                    <span class="descripcionCorta" [innerHTML]="perfil.descripcion_larga.length > 500 ? perfil.descripcion_larga.substr(0, 500) + '...' :
                        perfil.descripcion_larga">
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>